import { useEffect } from "react";
import { Link } from "react-router";

export function NotFoundRoute() {
	useEffect(() => {
		document.title = "Page not found · GenieWorlds";
	}, []);

	return (
		<div className="mx-auto max-w-xl px-6 py-24 text-center space-y-6">
			<div className="text-8xl" aria-hidden="true">
				👾
			</div>
			<h1 className="font-display font-extrabold text-4xl md:text-5xl text-ink">
				Page not found
			</h1>
			<p className="text-ink-muted">
				We couldn't find the page you were looking for. It may have
				been moved, or it never existed in the first place.
			</p>
			<div className="flex items-center justify-center gap-3">
				<Link
					to="/"
					className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-primary text-background font-semibold hover:shadow-[0_0_24px_rgba(0,255,136,0.4)] transition-all duration-300"
				>
					Back to home
				</Link>
				<Link
					to="/browse"
					className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-surface border border-border text-ink font-semibold hover:border-purple hover:text-purple transition-all duration-200"
				>
					Browse games
				</Link>
			</div>
		</div>
	);
}
